import { SharedFoldersState } from './sharedFolder.types'

export const state: SharedFoldersState = {
  sharedFolders: [],
  sortOption: 'created_at-desc',
  isFetching: false,
  isCreating: false,
  sharedFolder: undefined,
  error: undefined,
  createFolderError: false,
  deleteFolderError: false,
  updateFolderError: false,
  getFolderError: false,
  getFoldersError: false,
  getSortedFoldersError: false,
  getTechpacksError: false,
  removeTechpackError: false,
  getSignedURLError: false,
  getShareLinkError: false,
  emailPublicLinkError: false
}
